module.exports = __webpack_public_path__ + "img/long-covid-definitions-image-center.6cca2095.png";